import { render, staticRenderFns } from "./productAtlas.vue?vue&type=template&id=7437f499&scoped=true&"
import script from "./productAtlas.vue?vue&type=script&lang=js&"
export * from "./productAtlas.vue?vue&type=script&lang=js&"
import style0 from "./productAtlas.vue?vue&type=style&index=0&id=7437f499&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7437f499",
  null
  
)

export default component.exports